import { PRPage } from './pages';

export const prRoutes = [
  {
    path: 'pr',
    component: PRPage,
    requiredPermission: 'pr.view',
  },
];
